import moment from "moment";

// Interfaces
import { TPayPeriodPart } from "@/Common/api/types/CommissionCycle";
import { IGetPayPeriodPartsParams } from "./interfaces";

// Helpers
import { number2ordinal } from "@Common/helpers/number";
import { DATE_FORMAT } from "@/Constants/date";

const getOrdinalLabel = (n1: number, n2: number) => `${number2ordinal(n1)}-${number2ordinal(n2)}`;

function formatDateRange(startDate?: Date, endDate?: Date, isOrdinal = false) {
	const start = moment.utc(startDate);
	const end = moment.utc(endDate);

	if (isOrdinal) {
		const startDay = start.format(DATE_FORMAT.day);
		const endDay = end.format(DATE_FORMAT.day);
		const ordinalDate = getOrdinalLabel(+startDay, +endDay);
		return `${start.format(DATE_FORMAT.monthAbbr)} ${ordinalDate} ${end.format(DATE_FORMAT.yearOnly)}`;
	}

	return `${start.format(DATE_FORMAT.monthDayAbbr)}-${end.format(DATE_FORMAT.dayYear)}`;
}

function getPayPeriodParts(args: IGetPayPeriodPartsParams): TPayPeriodPart[] {
	const { commissionCycle, payPeriod, partnerPayPeriod, isOrdinal = false } = args ?? {};
	const payPeriodParts = [
		{
			startDate: payPeriod?.startDate,
			endDate: payPeriod?.endDate,
			ccId: commissionCycle?._id,
		},
	];

	if (partnerPayPeriod?.nextCCId || partnerPayPeriod?.previousCCId) {
		payPeriodParts.push({
			startDate: partnerPayPeriod?.startDate,
			endDate: partnerPayPeriod?.endDate,
			ccId: payPeriod?.nextCCId ?? payPeriod?.previousCCId,
		});
	}

	return payPeriodParts
		.sort((a, b) => moment(a.startDate).diff(moment(b.startDate)))
		.map((part) => ({ ...part, label: formatDateRange(part.startDate, part.endDate, isOrdinal) }));
}

export { getPayPeriodParts };
